<template>
<div id="health-registration-form" class="pb-4" ref="hf">
	<div class="field" :key='"key"+i' v-for="(healthQuestionItem, i) in hb">
		<label class="label">{{ healthQuestionItem.question }}</label>
		<div
			class="control has-text-left"
			v-if="healthQuestionItem.typeAnswer === MedicalAnswerType.YN || healthQuestionItem.typeAnswer === MedicalAnswerType.YWN">
			<label class="radio">
				<input type="radio" :name="healthQuestionItem.questionId" v-model="healthQuestionItem.answer" value="SI"/>
				Sí
			</label>
			<label class="radio">
				<input type="radio" :name="healthQuestionItem.questionId" v-model="healthQuestionItem.answer" value="NO"/>
				No
			</label>
			<div v-if="healthQuestionItem.typeAnswer === MedicalAnswerType.YWN">
				<label class="label">{{ healthQuestionItem.ywLabel }}</label>
        <div class="control">
          <input class="input" type="text" placeholder="" v-model="healthQuestionItem.extraAnswer"/>
        </div>
			</div>
		</div>
		<div v-else-if="healthQuestionItem.typeAnswer === MedicalAnswerType.OPTIONS">
			<div class="has-text-left" :key="'option'+i" v-for="(option, i) in healthQuestionItem.options">
				<label class="radio">
					<input type="radio"
						:name="healthQuestionItem.questionId"
						v-model="healthQuestionItem.answer"
						:value="option"/>
					{{ option }}
				</label>
			</div>
		</div>
	</div>
</div>
</template>

<script lang="ts">
import AuthFacade from "@/infraestructure/auth/auth_facade";
import { MedicalBackground } from '@/domain/entities/MedicalBackground';
import { MedicalAnswerType } from '@/domain/entities/MedicalQuestion';
import { PatientRepository } from '@/infraestructure/patient/PatientRepository';
import { pprint } from '@/helpers/pprint'
import {
	defineComponent,
	onMounted,
	// reactive,
	ref,
	inject,
} from "vue";

export default defineComponent({
	name: 'health-form',
	props: {
		modelValue: Object
	},
	async setup(_, {emit}) {
		const hf = ref<HTMLElement | null>(null)
		onMounted(() => {
			hf.value?.addEventListener('input', (ev) => {
				pprint('input ev', ev)
				emit('update:modelValue', hb.value)
			})
		})

		let patientRespository = inject(PatientRepository.key) as PatientRepository
		let authFacade = inject(AuthFacade.key) as AuthFacade
	
		const hb = ref<MedicalBackground[] | null>(null)
		hb.value = await patientRespository.fetchAndFormatHealthInformation(authFacade.user?.uid || '')
		pprint('hb', hb.value)

		return {
			hb, MedicalAnswerType, hf
		}
	}
})
</script>

<style lang="stylus" scoped>
#health-registration-form
	text-align center
.registration-container
	max-width 400px
	margin 0 auto
.label
	text-align left
</style>


